// extracted by mini-css-extract-plugin
module.exports = {"ContactBlock":"ContactBlock_ContactBlock__1DDs8","Wrapper":"ContactBlock_Wrapper__1UXLA"};